import strings from '../localization';

export default {
  active: strings.member_statuses.active,
  waiting_approval: strings.member_statuses.waiting_approval,
  declined: strings.member_statuses.declined,
  left_community: strings.member_statuses.left_community,
};
